export default __webpack_public_path__ + "static/media/Kannada_dm_1.564a4b3e.mp3";